import * as React from 'react'

const SvgPulseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 17.125a.625.625 0 01-.575-.387L2.956 9.625H.25v-1.25h3.125c.252.001.48.154.575.387L6.5 14.8l5.037-13.519a.625.625 0 01.588-.406.625.625 0 01.581.425l2.369 7.075h2.675v1.25h-3.125a.625.625 0 01-.594-.425l-1.906-5.825-5.037 13.344a.625.625 0 01-.588.406z"
      fill="#163250"
    />
  </svg>
)

export default SvgPulseIcon
